import React from "react";
import { useState } from "react";

function Earning() {
  const [netEarning, setNetEarning] = useState("");

  const [earningInrupees, setEarningInRupees] = useState("");

  function convertToRupees() {
    const apiUrl = `https://api.freecurrencyapi.com/v1/latest?apikey=VNU5p3NuxIscp1NabZRFV7ICw5E3qfc8HjwJp6GG&currencies=INR`;
    const url = `${apiUrl}&base=USD`;
    fetch(url)
      .then((response) => {
        return response.json();
      })

      .then((data) => {
        const exchangeRate = data.data.INR - 2;

        const rupeeAmount = (netEarning * exchangeRate).toFixed(3);
        setEarningInRupees(rupeeAmount);
      })
      .catch((error) => console.log(error));
  }

  function handleTax(e) {
    const amount = ((e * 21) / 100).toFixed(3);
    const remaingAmount = e - amount;
    console.log(remaingAmount);
    setNetEarning(remaingAmount);
  }
  return (
    <>
      <h2> Calculate Earning</h2>

      <div className="calculateEarning">
        <div className="insideCalculateEarning">
          <span className="span-inputBox"> Project Earning </span>

          <div className="input-sign-holder">
            <span className="currency-sign">$</span>
            <input className="dark-input padding-input"
              type="number"
              onChange={(e) => handleTax(e.target.value)}
              onBlur={() => convertToRupees()}
            ></input>
          </div>
        </div>

        <div className="insideCalculateEarning space-insideCalculateEarning">
          <span className="span-inputBox">Estimate Net Earning </span>

          <div className="input-sign-holder">
            <span className="currency-sign">$</span>
            <input
              className="displaySpan readOnly padding-input"
              type="text"
              readOnly
              value={netEarning}
            />
          </div>
        </div>

        <div className="insideCalculateEarning">
          <span className="span-inputBox">Estimate Earning In Rupees </span>
          <div className="input-sign-holder">
            <span className="currency-sign">₹</span>
            <input
              className="displaySpan readOnly padding-input"
              type="text"
              readOnly
              value={earningInrupees}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Earning;
